import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import SideMenuMySettings from "./SideMenuMySettings";
import AuthenticationQuestions from "./Tabs/AuthenticationQuestions/AuthenticationQuestions";
import MessageOptions from "./Tabs/MessageOptions/MessageOptions";
import MailboxDelegation from "./Tabs/MailboxDelegation/MailboxDelegation";
import { fetchUserSettings, updateUserSettings } from "src/actionCreators/userSettingsActionCreators";
import { IUserSettingsModel } from "src/Core/ViewModels/User/UserViewModel";
import { ApplicationState } from "src/store";
import { actionTypes } from "src/types/userSettingsTypes";
import "../AdminSettings/style.css";
import "../AdminSettings/style.scss";
import MessageNotification from "./Tabs/Notification/MessageNotification";
import EmailMessageTemplates from "./Tabs/EmailMessageTemplate";
import DefaultTaxYear from "./Tabs/DefaultTaxYear";

const MySettingsRoutes: React.FC = () => (
    <Routes>
        <Route path="/authentication-questions" element={<AuthenticationQuestions />}></Route>
        <Route path="/message-options" element={<MessageOptions />}></Route>
        <Route path="/mailbox-delegation" element={<MailboxDelegation />}></Route>
        <Route path="/notifications" element={<MessageNotification />}></Route>
        <Route path="/email-template" element={<EmailMessageTemplates />}></Route>
        <Route path="/default-tax-year" element={<DefaultTaxYear />}></Route>
    </Routes>
);

const MySettings: React.FC = () => {
    const dispatch = useDispatch();
    const { userSettings } = useSelector((appState: ApplicationState) => appState.userSettingsState);
    const [userSettingsCopy, setUserSettingsCopy] = useState<IUserSettingsModel>();

    useEffect(() => {
        dispatch(
            fetchUserSettings(data => {
                setUserSettingsCopy(data);
            })
        );
    }, []);

    const handleApplySettings = () => {
        if (userSettings) {
            dispatch(updateUserSettings(userSettings, () => Office.context.ui.messageParent("close")));
        }
    };

    const handleCancel = () => {
        dispatch({
            type: actionTypes.UPDATE_USER_SETTINGS,
            payload: userSettingsCopy,
        });
        Office.context.ui.messageParent("close");
    };

    return (
        <div className="settings-wrapper">
            <header>My Settings</header>
            <main>
                <SideMenuMySettings />
                <div className="settings-tab-wrapper">
                    <MySettingsRoutes />
                </div>
            </main>
            <div className="settings-tab-footer">
                <button className="btn btn-light" onClick={handleCancel}>
                    Cancel
                </button>
                <button className="btn btn-primary" onClick={handleApplySettings}>
                    Apply
                </button>
            </div>
        </div>
    );
};

export default MySettings;
